/**************************************************
 * Nombre:       Seccion_Prueba
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {
    AddBoxOutlined,
    AssignmentInd,
    AssignmentReturn,
    CleaningServicesOutlined,
    IndeterminateCheckBoxOutlined,
    ManageSearch,
    PointOfSaleSharp
} from '@mui/icons-material'
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import Dialogo_Reserva from "../Dialogos/Reservas/Dialogo_Reserva";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_FUNCION_MONEDA, CASILLA_FUNCION_MONEDA_FECHA,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {
    ESTADOSRESERVAS,
    ESTADOSRESERVASCOMPLETO,
    FECHACHECKIN,
    FECHACHECKOUT,
    ORIGENESRESERVAS
} from "../../Modulo_Motor_Reservas/Constantes";
import Dialogo_Abonos from "../Dialogos/Reservas/Dialogo_Abonos";
import Dialogo_CheckIn from "../Dialogos/Reservas/Dialogo_CheckIn";
import Dialogo_CheckOut from "../Dialogos/Reservas/Dialogo_CheckOut";
import Dialogo_Adicionales from "../Dialogos/Reservas/Dialogo_Adicionales";
import Dialogo_Descuentos from "../Dialogos/Reservas/Dialogo_Descuentos";
import React, {useContext, useEffect, useRef, useState} from "react";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import {usuarioContext} from "../../App";
import {obtenerHabitaciones} from "../../Modulo_Motor_Reservas/Controladores/obtenerHabitaciones";
import {where} from "firebase/firestore";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import Linea_Limpia from "../../Modulo_Graficas/Graficas/Linea_Limpia";
import {arrConteoColAnoAtrasSuma} from "../../Modulo_Motor_Reservas/Controladores/arrConteoColAnoAtrasSuma";
import Barras_Horizontales_Nombre from "../../Modulo_Graficas/Graficas/Barras_Horizontales_Nombre";
import {arrConteoColPropiedadEstados} from "../../Servicios/BD/Contadores_Arr/arrConteoColPropiedadEstados";
import ExportadorDatos from "../Componentes/ExportadorDatos";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {obtenerValorSaldo} from "../../CodNegocio/obtenerValorSaldo";

const Seccion_Reservas = () => {
    const refe = useRef()
    const altoGraficas = 190
    const {alto} = useObtenerAlto({contenedor: refe})
    const [reservasOcu, setReservasOcu] = useState([])
    const [reservasOcuAnterior, setReservasOcuAnterior] = useState([])
    const [reservasOcuTrasAnterior, setReservasOcuTrasAnterior] = useState([])
    const [origenes, setOrigenes] = useState([])
    const usuario = useContext(usuarioContext).usuario
    const {
        props,
        cargarNuevamente,
    } = useObtenerColleccionTabla2025({coleccion: 'reservas'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Reserva,
        titulo: 'Detalles del reserva',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoAdicionales, abrir: abrirAdicionales} = useDialogo({
        Componente: Dialogo_Adicionales,
        titulo: 'Detalles de adicionales',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoDescuentos, abrir: abrirDescuentos} = useDialogo({
        Componente: Dialogo_Descuentos,
        titulo: 'Detalles de descuentos',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoAbono, abrir: abrirAbono} = useDialogo({
        Componente: Dialogo_Abonos,
        titulo: 'Detalles de abonos',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoCheckIn, abrir: abrirChechIn} = useDialogo({
        Componente: Dialogo_CheckIn,
        titulo: 'Detalles de CheckIn',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoCheckOut, abrir: abrirChechOut} = useDialogo({
        Componente: Dialogo_CheckOut,
        titulo: 'Detalles de CheckOut',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        // console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'adicionales':
                abrirAdicionales(data)
                break
            case 'descuentos':
                abrirDescuentos(data)
                break
            case 'abonos':
                abrirAbono(data)
                break
            case 'checkIn':
                abrirChechIn(data)
                break
            case 'checkOut':
                abrirChechOut(data)
                break
            case 'limpiar':
                limipiar(data)
                break
            default :
                abrir(data)

        }
    }


    const limipiar = async (data) => {

        if (data.estado === 'Limpieza') {
            data.estado = 'Completada'
            let dox = await guardarDoc('reservas', data)
            cargarNuevamente()
        }

    }



    const obtenerDatos = async () => {


        let arrHabitaciones = await obtenerHabitaciones()
        let fecha_ = new Date()


        let w = [where('estado', '!=', ESTADOSRESERVAS[5])]
        let yearAcutual = fecha_.getFullYear()
        let arrReservasOcupacion = await arrConteoColAnoAtrasSuma({
            coleccion: 'reservas',
            year: yearAcutual,
            wheres: w,
            propiedad: 'numNoches',
            numHabitaciones: arrHabitaciones.length
        })
        setReservasOcu(arrReservasOcupacion)

        let arrReservasOcupacionYearAnterior = await arrConteoColAnoAtrasSuma({
            coleccion: 'reservas',
            year: yearAcutual - 1,
            wheres: w,
            propiedad: 'numNoches',
            numHabitaciones: arrHabitaciones.length
        })
        setReservasOcuAnterior(arrReservasOcupacionYearAnterior)

        let arrReservasOcupacionYearTrasAnterior = await arrConteoColAnoAtrasSuma({
            coleccion: 'reservas',
            year: yearAcutual - 1,
            wheres: w,
            propiedad: 'numNoches',
            numHabitaciones: arrHabitaciones.length
        })
        setReservasOcuTrasAnterior(arrReservasOcupacionYearTrasAnterior)


        let origenes_ = await arrConteoColPropiedadEstados({
            coleccion: 'reservas',
            propiedad: 'origen',
            arrEstados: ORIGENESRESERVAS,
            wheres: w
        })

        setOrigenes(origenes_)

    }


    useEffect(() => {
        obtenerDatos()
    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >


                <Dialogo/>

                <DialogoAdicionales/>

                <DialogoDescuentos/>

                <DialogoAbono/>

                <DialogoCheckIn/>

                <DialogoCheckOut/>

                <Grid ref={refe} container size={{xs: 12, sm: 12, md: 8}}>
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Ocupacion del hotel'}
                        subtitulo={'Ultimos 3 años'}
                        Grafica={Linea_Limpia}
                        marginTop={12}
                        height={altoGraficas}
                        series={
                            [
                                {
                                    name: new Date().getFullYear(),
                                    data: reservasOcu.map((it) => it.cantidad)

                                },
                                {
                                    name: new Date().getFullYear() - 1,
                                    data: reservasOcuAnterior.map((it) => it.cantidad)

                                },
                                {
                                    name: new Date().getFullYear() - 2,
                                    data: reservasOcuTrasAnterior.map((it) => it.cantidad)

                                }
                            ]
                        }
                        labels={reservasOcuTrasAnterior.map((it) => it.nombre)}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 3, md: 4}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Origen'}
                        subtitulo={'de reservas'}
                        Grafica={Barras_Horizontales_Nombre}
                        marginTop={20}
                        height={altoGraficas - 40}
                        series={
                            [{
                                name: 'Reservas',
                                data: origenes.map((e) => e.cantidad)
                            }]
                        }

                        labels={origenes.map((e) => e.nombre)}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Reservaciones '}
                        descripcion={'Martes 24 Feb 2024'}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        ComponenteInferior={ExportadorDatos}

                    />
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Reservas

const filtros = [
    {
        nombre: 'Nombres',
        direccion: 'asc',
        propiedad: 'nombres'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]

const calcularSaldo = (data) => {

    console.log(data)

    let valorReserva = data.valor
    let saldo = obtenerValorSaldo({
        totalReserva: valorReserva,
        abonos: data.abonos,
        descuentos: data.descuentos,
        adicionales: data.adicionales
    })

    console.log(saldo)
    return saldo
}


const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['nombres', 'apellidos'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS

    },
    {
        nombre: 'Id',
        direccion: 'left',
        titulo: 'tipoCc',
        propiedad: 'cc',
        tipo: CASILLA_TITULO_DATO
    },

    {
        nombre: 'Check In',
        direccion: 'left',
        fecha: FECHACHECKIN,
        propiedades: ['numero', 'tipo'],
        tipo: CASILLA_FECHA_DATOS,

    },
    {
        nombre: 'Check Out',
        direccion: 'left',
        fecha: FECHACHECKOUT,
        propiedad: 'productos',
        funcion: calcularSaldo,
        tipo: CASILLA_FUNCION_MONEDA_FECHA,

},
{
    nombre: 'Estado',
        direccion
:
    'right',
        propiedad
:
    'estado',
        tipo
:
    CASILLA_ESTADO,
        estados
:
    ESTADOSRESERVASCOMPLETO
}
,


]

const botonesInferiores = [
    <Button>Hola</Button>
]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Adicionales',
        id: 'adicionales',
        icono: AddBoxOutlined
    },
    {
        nombre: 'Descuentos',
        id: 'descuentos',
        icono: IndeterminateCheckBoxOutlined
    },
    {
        nombre: 'Abonos',
        id: 'abonos',
        icono: PointOfSaleSharp
    },
    {
        nombre: 'Check In',
        id: 'checkIn',
        icono: AssignmentInd
    },
    {
        nombre: 'Check Out',
        id: 'checkOut',
        icono: AssignmentReturn
    },
    {
        nombre: 'Limpiar',
        id: 'limpiar',
        icono: CleaningServicesOutlined
    },
]


